import { forwardRef } from "react";
import SvgIcon from "@mui/material/SvgIcon";
import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTag = forwardRef((props, ref) => {
	return React.createElement(SvgIcon, {
		...props,
		ref
	}, /* @__PURE__ */ _jsxs("g", {
		stroke: "currentColor",
		strokeWidth: 1.5,
		strokeLinejoin: "round",
		strokeLinecap: "round",
		fill: "none",
		children: [/* @__PURE__ */ _jsx("path", {
			stroke: "null",
			id: "svg_2",
			d: "m0.75665,2.30746l0,6.47271c0.00019,0.82288 0.3272,1.61199 0.90916,2.19377l12.02903,12.02897c0.09925,0.09945 0.22361,0.16989 0.35983,0.20417c0.1362,0.03413 0.27914,0.03072 0.41356,-0.00993c0.13442,-0.04065 0.25528,-0.11698 0.34968,-0.22108c0.09441,-0.10395 0.15881,-0.23148 0.18636,-0.36925l1.2671,-6.33618l6.33618,-1.26703c0.13761,-0.02754 0.2653,-0.09196 0.36925,-0.18636c0.10395,-0.09441 0.18044,-0.21527 0.22108,-0.34968c0.04065,-0.13442 0.04406,-0.27736 0.00977,-0.41356c-0.03413,-0.1362 -0.10472,-0.26057 -0.20402,-0.35983l-12.02905,-12.02902c-0.58177,-0.58195 -1.37089,-0.90899 -2.19377,-0.90916l-6.47271,0c-0.41146,0 -0.80609,0.16345 -1.09704,0.45441c-0.29096,0.29096 -0.45442,0.68558 -0.45442,1.09706z"
		}), /* @__PURE__ */ _jsx("path", {
			stroke: "null",
			id: "svg_3",
			d: "m4.63531,6.18613c0,0.20374 0.04014,0.40548 0.1181,0.59371c0.07798,0.18824 0.19226,0.35927 0.33633,0.50333c0.14405,0.14407 0.31509,0.25835 0.50333,0.33633c0.18822,0.07796 0.38998,0.1181 0.59371,0.1181c0.20374,0 0.40549,-0.04014 0.59373,-0.1181c0.18822,-0.07798 0.35926,-0.19226 0.50333,-0.33633c0.14407,-0.14405 0.25835,-0.31509 0.33631,-0.50333c0.07798,-0.18824 0.1181,-0.38998 0.1181,-0.59371c0,-0.20375 -0.04012,-0.40549 -0.1181,-0.59373c-0.07796,-0.18822 -0.19224,-0.35926 -0.33631,-0.50333c-0.14407,-0.14407 -0.3151,-0.25835 -0.50333,-0.33631c-0.18824,-0.07798 -0.38999,-0.1181 -0.59373,-0.1181s-0.40549,0.04012 -0.59371,0.1181c-0.18824,0.07796 -0.35927,0.19224 -0.50333,0.33631c-0.14407,0.14407 -0.25835,0.3151 -0.33633,0.50333c-0.07796,0.18824 -0.1181,0.38998 -0.1181,0.59373z"
		})]
	}));
});
export default SvgTag;
